import { NgModule } from '@angular/core';
import { FontAwesomeModule, FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { fas as fontawesomeSolid } from '@fortawesome/pro-solid-svg-icons';
import { far as fontawesomeRegular } from '@fortawesome/pro-regular-svg-icons';
import { fal as fontawesomeLight } from '@fortawesome/pro-light-svg-icons';

/**
 * As per https://github.com/FortAwesome/angular-fontawesome/blob/master/docs/guide/testing.md
 * making a wrapper for FontAwesome icons when using icon library mode reduces duplicate code in test specs.
 */
@NgModule({
  imports: [FontAwesomeModule],
  exports: [FontAwesomeModule],
})
export class FontAwesomeIconsModule {
  constructor(library: FaIconLibrary) {
    library.addIconPacks(fontawesomeSolid, fontawesomeRegular, fontawesomeLight);
  }
}